import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Controls from './controls';
import Form from './form';
import Modal from 'components/modal';

export default function ListingSearch({
  deal,
  edgeCrm,
  onClose,
  onConfirmMerge,
  onCreateClick,
  onSave,
}) {
  const [project, setProject] = useState();
  const [listing, setListing] = useState();
  const [propertyIdOverride, setPropertyIdOverride] = useState(null);
  const [confirmationMessage, setConfirmationMessage] = useState('');

  function handleProjectChange(project) {
    setProject(project);
    setListing(null);
    setPropertyIdOverride(null);
    setConfirmationMessage('');
  }

  function setConfirmationValues(message, propertyId) {
    setConfirmationMessage(message);
    setPropertyIdOverride(propertyId);
  }

  return <React.Fragment>
    <Modal.Body>
      <Form
        confirmationMessage={confirmationMessage}
        deal={deal}
        edgeCrm={edgeCrm}
        listing={listing}
        project={project}
        propertyIdOverride={propertyIdOverride}
        onListingChange={setListing}
        onProjectChange={handleProjectChange}
        onPropertyIdOverrideChange={value => setPropertyIdOverride(parseInt(value))}
      />
    </Modal.Body>

    <Modal.Footer>
      <Controls
        deal={deal}
        edgeCrm={edgeCrm}
        listing={listing}
        project={project}
        propertyIdOverride={propertyIdOverride}
        onClose={confirmationMessage ? () => setConfirmationValues('', null) : onClose}
        onConfirm={setConfirmationValues}
        onConfirmMerge={onConfirmMerge}
        onCreateClick={onCreateClick}
        onSave={onSave}
      />
    </Modal.Footer>
  </React.Fragment>;
}

ListingSearch.propTypes = {
  deal: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirmMerge: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
